//#image-credits
import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../components/Breadcrumb";

function PictureCredits() {
  const [content, setContent] = useState({ entries: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(
          "/api/information/public/pictureCredits"
        );
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching picture credits content:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="pt-[60px] px-4 max-w-4xl mx-auto text-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="pt-[60px] px-4 max-w-4xl mx-auto mt-20 pb-8">
      <div className="-ml-3 -mt-16 sm:mt-0 sm:ml-0">
        <Breadcrumb
          items={[
            { label: "Home", href: "/" },
            {
              label: "Image Credits",
              href: "/image-credits",
            },
          ]}
        />
      </div>
      <h1 className="text-3xl font-cinzel mb-6 mt-12">Image Credits</h1>
      <div className="prose max-w-none">
        {content.entries && content.entries.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left font-semibold">
                    Photo
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left font-semibold">
                    Courtesy Of
                  </th>
                </tr>
              </thead>
              <tbody>
                {content.entries.map((entry, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-4 py-2">
                      {entry.photo}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {entry.courtesyOf}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No picture credits available at this time.</p>
        )}
      </div>
    </div>
  );
}

export default PictureCredits;
